export const DEFAULT_VIDEO_TIMEOUT_SEC = 5;
export const PROGRESS_BAR_UPDATE_INTERVAL_SEC = 0.25;
